import { useState } from "react";
import Header from "../components/dashboard/Header";
import { AvailabilityPanel, useLocationOptions } from "../components/AvailabilityPanel";

export default function Availability() {
  const [location, setLocation] = useState(() => new URLSearchParams(window.location.search).get("location") || "all");
  const locations = useLocationOptions();
  return (
    <div className="min-h-screen bg-brand-page relative z-10">
      <Header />
      <main className="max-w-[1280px] mx-auto px-6 lg:px-12 py-10">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-brand-tertiary">Locations &amp; Members</p>
            <h1 className="font-serif text-4xl lg:text-5xl font-light tracking-tight text-brand-ink mt-2">Availability</h1>
            <p className="text-sm text-brand-muted mt-1">Live office inventory from Yardi — what's open now and what's freeing up.</p>
          </div>
          <select value={location} onChange={(e) => setLocation(e.target.value)} data-testid="availability-location"
            className="border border-brand-border rounded-md px-3 py-2 text-sm bg-brand-surface text-brand-ink">
            <option value="all">All locations</option>
            {locations.map((l) => <option key={l} value={l}>{l}</option>)}
          </select>
        </div>
        <AvailabilityPanel location={location} onSelectLocation={setLocation} />
      </main>
    </div>
  );
}
